module.exports = __webpack_public_path__ + "files/8f8541f713e2e4255a69f27ad3cbaf00.png";